import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  InputStakeholderDialogContext,
  InputStakeholderDialogInitialState,
} from "./";

export const InputStakeholderDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    InputStakeholderDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <InputStakeholderDialogContext.Provider value={context}>
      {children}
    </InputStakeholderDialogContext.Provider>
  );
};
